// Order/map read boundaries only. Coordinate provenance and local placement
// authority belong to the caller; delivery-proof GPS has a different contract.
const DECIMAL_NUMBER = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/;

const finiteCoordinateNumber = (value, allowNumericStrings) => {
  if (typeof value === 'string' && allowNumericStrings) {
    const text = value.trim();
    if (!DECIMAL_NUMBER.test(text)) return null;
    value = Number(text);
  }
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
};

export function readCoordinatePair(latitude, longitude, { allowNumericStrings = true } = {}) {
  const lat = finiteCoordinateNumber(latitude, allowNumericStrings);
  const lng = finiteCoordinateNumber(longitude, allowNumericStrings);
  if (lat === null || lng === null || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { latitude: lat, longitude: lng };
}

export function readOrderCoordinate(order) {
  if (!order || typeof order !== 'object' || Array.isArray(order)) return null;
  return readCoordinatePair(order.latitude, order.longitude);
}
